function totalNumber(all_data, column) {
    const data_l = all_data.length;
    let i;
    let cp_array = [];
    for (i = 0; i < data_l; i++) {
        cp_array.push(all_data[i][column]);
    }
    // TODO does not work for empty or one number in array
    const reducer = (accumulator, currentValue) => accumulator + currentValue;
    return cp_array.reduce(reducer);
}

export { totalNumber };
